<h2 mat-dialog-title>Auto-Assign complete</h2>

<mat-dialog-content>
  <div class="result-grid">
    <div class="result-card">
      <span class="result-label">Games processed</span>
      <strong>{{ processedGameCount }}</strong>
    </div>
    <div class="result-card" [class.result-card-failed]="failedGameCount > 0">
      <span class="result-label">Failed games</span>
      <strong>{{ failedGameCount }}</strong>
    </div>
  </div>

  <div class="assignment-summary">
    <span class="result-label">Assignment writes</span>
    <span>
      {{ attemptedAssignmentCount }} attempted,
      {{ modifiedAssignmentCount }} modified
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>Close</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="downloading || processedGameCount === 0"
    (click)="downloadReport()"
  >
    {{ downloading ? 'Downloading...' : 'Download PDF report' }}
  </button>
</mat-dialog-actions>
